import { createReducer, on, Action } from '@ngrx/store';
import { loaderAnimationShow, loaderAnimationHide } from './action';

export interface State {
  visible: boolean;
}

const initialState: State = {
  visible: false,
};

const _pageLoaderReducer = createReducer(
  initialState,
  on(loaderAnimationShow, () => ({
    visible: true,
  })),
  on(loaderAnimationHide, () => ({
    visible: false,
  })),
);

export function pageLoaderReducer(state: State = initialState, action: Action) {
  return _pageLoaderReducer(state, action);
}
